import { render, staticRenderFns } from "./c_tabs.vue?vue&type=template&id=e01df6c4&scoped=true"
import script from "./c_tabs.vue?vue&type=script&lang=js"
export * from "./c_tabs.vue?vue&type=script&lang=js"
import style0 from "./c_tabs.vue?vue&type=style&index=0&id=e01df6c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01df6c4",
  null
  
)

export default component.exports